import { Loader } from 'pixi.js';
import eventHub from '@/scripts/eventHub';
import Flower from './Flower';

class SuperFlower extends Flower {
  constructor(parent, x, y = 0) {
    const flowerSheet = Loader.shared.resources['images/FLOWERS'].spritesheet.textures;
    super(
      parent,
      x,
      y,
      'superflower',
      [
        flowerSheet['flower-super_1.png'],
        flowerSheet['flower-super_2.png'],
        flowerSheet['flower-super_3.png'],
        flowerSheet['flower-super_4.png'],
        flowerSheet['flower-super_5.png'],
      ],
    );

    this.isSuper = true;
  }

  resize() {
    super.resize();
    this.sprite.scale.x = 1.2;
    this.sprite.scale.y = 1.2;
  }

  catch() {
    // Execute normal flower pop
    super.catch();

    eventHub.$emit('blow-all');
  }
}

export default SuperFlower;
